import SendGridForm from "./SendGridForm";
import SmtpForm from "./SmtpForm";

export const emailConfigs = [
  {
    title: "SendGrid",
    component: SendGridForm,
  },
  {
    title: "SMTP",
    component: SmtpForm,
  },
  // {
  //   title: "Mailgun",
  //   component: SendGridForm,
  // },
];